var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('HelloWorld',{attrs:{"msg":"L'infogérance 2.0, c'est un fonctionnement DevOps et une UX Smart !"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }